<template>
    <div>
        <!-- Overview -->
        <div class="box">
            <div class="campaign-form-title">
                {{ customizationText('overview_header', 'Overview') }}
            </div>
            <p v-if="campaign.objective" v-html="$sanitize(campaign.objective)"></p>
        </div>
    </div>
</template>
<script>
    import { nl2br } from '../../../helpers';
    import AddressInfo from '../settings/profile/AddressInfo.vue';
    import CampaignCustomizeMixin from '../../../mixins/CampaignCustomizeMixin';
    import CampaignAdditionalFields from './proposal/requirements/CampaignAdditionalFields.vue';

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'CampaignHeader',

        /**
         * The component mixins
         *
         * @type {array}
         */
        mixins: [CampaignCustomizeMixin],

        /**
         * The child components
         *
         * @type {object}
         */
        components: {
            AddressInfo,
            CampaignAdditionalFields
        },

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type: Object,
                required: true
            }
        },

        /**
         * The component data
         *
         * @returns {object}
         */
        data() {
            return {
                /**
                 * The read more boolean
                 *
                 * @type {boolean}
                 */
                read_more: false
            };
        },

        /**
         * The component methods
         *
         * @type {object}
         */
        methods: {
            /**
             * nl2br helper
             *
             * @param {string} text
             * @returns {string}
             */
            newlineToBreak(text) {
                return text ? nl2br(text) : '';
            }
        }
    };
</script>
